import { gql } from '@apollo/client'

export const OPERATION_TWO_FA_SESSION = gql`
  mutation TwoFaSession($code: String!, $token: String!) {
    tokens: twoFaSession(code: $code, token: $token) {
      access_token
      refresh_token
    }
  }
`
export const OPERATION_TWO_FA_SEND_CODE = gql`
  mutation TwoFaSendCode($user_id: ID, $token: String, $language: String!) {
    token: twoFaSendCode(user_id: $user_id, token: $token, language: $language)
  }
`

export const OPERATION_TWO_FA_ACTIVATE = gql`
  mutation TwoFaActivate($code: String!, $token: String!, $language: String!) {
    tokens: twoFaActivate(code: $code, token: $token, language: $language) {
      access_token
      refresh_token
    }
  }
`
const OPERATION_LOGIN = gql`
    mutation Login($email: String!, $password: String!, $language: String) {
        login(email: $email, password: $password, language: $language) {
            two_fa_activated
            two_fa_disclaimer
            two_fa_token
            two_fa_user_id
            access_token
            refresh_token
        }
    }
`

export const OPERATION_LOGIN_SSO = gql`
    mutation Sso($token: String!) {
        sso(token: $token) {
            access_token
            refresh_token
        }
    }
`

export const OPERATION_LOGIN_SSO_CENTER = gql`
    mutation Sso($token: String!) {
        sso_center(token: $token) {
            access_token
            refresh_token
        }
    }
`

export const OPERATION_NEW_PASSWORD = gql`
    mutation newPassword(
        $password: String!
        $confirmation: String!
        $token: String!
    ) {
        recovery: resetPassword(
            password: $password
            confirmation: $confirmation
            token: $token
        ) {
            status
        }
    }
`

export const OPERATION_CREATE_PASSWORD = gql`
    mutation createPassword(
        $password: String!
        $password_confirmation: String!
        $token: String!
    ) {
        recovery: createPassword(
            password: $password
            password_confirmation: $password_confirmation
            token: $token
        ) {
            status
        }
    }
`

export const OPERATION_RESET_FAKE = gql`
    mutation ResetFake {
        me: resetFake {
            access_token
            refresh_token
        }
    }
`

export const OPERATION_FAKE = gql`
    mutation Fake($email: String!) {
        me: fake(email: $email) {
            access_token
            refresh_token
        }
    }
`
export const OPERATION_ENTER_DEMO_MODE = gql`
    mutation EnterDemoMode($name: String!) {
        me: enterDemoMode(name: $name) {
            access_token
            refresh_token
        }
    }
`

export const OPERATION_EXIT_DEMO_MODE = gql`
    mutation ExitDemoMode {
        me: exitDemoMode {
            access_token
            refresh_token
        }
    }
`

export const OPERATION_RECOVERY_PASSWORD = gql`
  query RecoveryPassword($email: String!) {
    recovery: askPassword(email: $email) {
      status
    }
  }
`;

export const OPERATION_GET_SPONSOR_LINK = gql`
  query GetSponsorLink($token: String!) {
    sponsorLink(token: $token) {
      first_name
      last_name
      email
      default_selected_days
    }
  }
`;

export const OPERATION_GENERATE_SPONSOR_CODE = gql`
  mutation GenerateSponsorCode($token: String!, $ends_at: String!) {
    generateSponsorCode(token: $token, ends_at: $ends_at) {
      success
    }
  }
`;

export default OPERATION_LOGIN
